import { FIVE_MINUTES_IN_SECONDS, THIRTY_DAYS_IN_SECONDS } from '@/utils/constants'
import { isNullOrUndefined } from '@/utils/comparators'

/**
* Returns true if less than 5 minutes has passed since provided date.
* @param {date} string
*/
const fiveMinutesPolicyHasExpired = (date) => {
  return policyHasExpired(date, FIVE_MINUTES_IN_SECONDS)
}

/**
* Returns true if less than 30 days has passed since provided date.
* @param {date} string
*/
const thirtyDaysPolicyHasExpired = (date) => {
  return policyHasExpired(date, THIRTY_DAYS_IN_SECONDS)
}

/**
* Returns true if provided date compared to right now exceeds the number of seconds
* defined in constants for max storage time. If the number of seconds exceeds,
* the storage is considered to be stale.
* @param {date} string
* @param {seconds} integer
*/
const policyHasExpired = (date, seconds) => {
  if (isNullOrUndefined(date)) {
    return true
  } else {
    let created = new Date(date)
    let diffInSeconds = (new Date().getTime() - created.getTime()) / 1000
    return diffInSeconds > seconds
  }
}

export {
  fiveMinutesPolicyHasExpired,
  thirtyDaysPolicyHasExpired
}



// WEBPACK FOOTER //
// ./src/utils/cachePolicies.js